import { Fragment, type ReactElement, type ReactNode } from 'react';
import type { AnalyticsSurface } from '../AnalyticsSurface';
import { AssistSurfaceProvider } from './AssistSurfaceProvider';
import SurfaceAssistBar from './SurfaceAssistBar';

interface SurfaceAssistScopeProps {
    surface: AnalyticsSurface;
    children: ReactNode;
}

/**
 * Wraps a surface's page body in the reusable assist context so the title-bar
 * search box, the filter pills, and the (popover) response all share one assist
 * session. The visible controls live in the title's right toolbar via
 * {@link SurfaceAssistToolbar}; the response renders in the bar's dropdown. A
 * transparent passthrough when the surface opts out via `assist`.
 */
export default function SurfaceAssistScope({ surface, children }: SurfaceAssistScopeProps): ReactElement {
    if (surface.assist !== true) {
        return <Fragment>{children}</Fragment>;
    }
    return <AssistSurfaceProvider surfaceId={surface.id}>{children}</AssistSurfaceProvider>;
}

/** The assist search box for a surface's page title toolbar (filters live in its overlay). */
export function SurfaceAssistToolbar({ surface }: { surface: AnalyticsSurface }): ReactElement | null {
    return surface.assist === true ? <SurfaceAssistBar surface={surface} /> : null;
}
